import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { EdwardColors } from 'enums';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .line': {
        display: 'inline-flex',
        width: '60%',
        height: '2px',
        margin: '14px 0',
        padding: 0,
        position: 'relative',
        '& .bar': {
          width: '100%',
          height: '100%',
          backgroundColor: EdwardColors.GRAY_MEDIUM,
        },
        '& .indicator': {
          position: 'absolute',
          top: '-3px',
          width: '9px',
          height: '9px',
          borderRadius: '50%',
          marginLeft: '-3px',
          backgroundColor: EdwardColors.GRAY_DARKER,
          transition: 'left 0.3s cubic-bezier(0, 1, 0.5, 1)',
        },
      },
      '& .min, & .max': {
        width: '20%',
        color: theme.palette.grey[600],
        '&.min': { textAlign: 'left' },
        '&.max': { textAlign: 'right' },
        fontSize: '22px',
        fontWeight: 'bold',
      },

      '& .numbers': {
        width: '100%',
        position: 'relative',
        height: '1rem',
        padding: '0 20%',
        '& .current': {
          position: 'relative',
          width: '20%',
          textAlign: 'center',
          transform: 'translate(-50%, 0)',
          transition: 'left 0.3s cubic-bezier(0, 1, 0.5, 1)',
          fontSize: '22px',
          fontWeight: 'bold',
        },
      },
    },
  }),
);

export default useStyles;
